import { useEffect, useRef } from "react";

// TES-1383 — re-read when the doctor comes back to the portal. A meeting the
// patient cancels or moves while the doctor is in another tab or app used to
// stay on her screen as booked until she reloaded, which on 2026-10-15 was
// until she pressed "Anslut" on it.
//
// Switching tabs fires both `focus` and `visibilitychange`; the second within
// a second of the first is dropped.
export function useRefreshOnFocus(refresh: () => void, enabled = true): void {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;
  useEffect(() => {
    if (!enabled) return undefined;
    let last = 0;
    const run = () => {
      const now = Date.now();
      if (now - last < 1000) return;
      last = now;
      refreshRef.current();
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") run();
    };
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [enabled]);
}
